var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex align-center flex-wrap tag-container" },
    [
      !_vm.visibleTags.length && _vm.showTextNoTag
        ? _c("span", { staticClass: "az-text-small" }, [
            _vm._v(" Nenhuma tag cadastrada ")
          ])
        : _vm._l(_vm.visibleTags, function(tag, index) {
            return _c(
              "v-chip",
              {
                key: index,
                staticClass: "d-flex justify-space-between ma-0 pa-0 px-3",
                staticStyle: { "max-height": "22px" },
                attrs: {
                  color: _vm.chipBgColor(tag),
                  "text-color": _vm.chipTextColorValue(tag),
                  "x-small": _vm.useSmallChips
                }
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "tag-text",
                    class: {
                      "mr-4": _vm.canEdit,
                      "text-xxs": _vm.useSmallChips
                    }
                  },
                  [_vm._v(" " + _vm._s(tag) + " ")]
                ),
                _vm.canEdit
                  ? _c(
                      "v-btn",
                      {
                        staticClass: "tag-delete-button ml-2",
                        attrs: {
                          icon: "",
                          "x-small": "",
                          color: _vm.chipDeleteColor(tag)
                        },
                        on: {
                          click: function($event) {
                            return _vm.removeTag(tag)
                          }
                        }
                      },
                      [
                        _c("v-icon", { attrs: { small: "" } }, [
                          _vm._v("mdi-close")
                        ])
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          }),
      _vm.hiddenCount > 0
        ? _c(
            "v-tooltip",
            {
              staticClass: "ma-0 pa-0",
              attrs: { top: "" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on
                      return [
                        _c(
                          "v-chip",
                          _vm._g(
                            {
                              staticClass: "ma-0 pa-0 px-3",
                              staticStyle: { "max-height": "22px" },
                              attrs: {
                                color: _vm.effectiveChipColor,
                                "text-color": _vm.effectiveChipTextColor,
                                pill: "",
                                "x-small": _vm.useSmallChips
                              }
                            },
                            on
                          ),
                          [_vm._v(" +" + _vm._s(_vm.hiddenCount) + " ")]
                        )
                      ]
                    }
                  }
                ],
                null,
                false,
                958398699
              )
            },
            _vm._l(_vm.safeTags.slice(_vm.maxTagsDisplay), function(tag, i) {
              return _c("div", { key: i }, [
                _c("span", [_vm._v(_vm._s(tag))]),
                _c("br")
              ])
            }),
            0
          )
        : _vm._e(),
      _vm.canEdit
        ? [
            _vm.isAdding
              ? _c(
                  "div",
                  { staticClass: "ml-1" },
                  [
                    _c("v-text-field", {
                      staticClass: "tag-input",
                      attrs: {
                        "hide-details": "",
                        type: "text",
                        placeholder: "Nova tag",
                        dense: "",
                        outlined: ""
                      },
                      on: {
                        keyup: [
                          function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.confirmAdd($event)
                          },
                          function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k($event.keyCode, "esc", 27, $event.key, [
                                "Esc",
                                "Escape"
                              ])
                            ) {
                              return null
                            }
                            return _vm.cancelAdd($event)
                          }
                        ],
                        blur: _vm.cancelAdd
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "append",
                            fn: function() {
                              return [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      icon: "",
                                      "x-small": "",
                                      color: "primary"
                                    },
                                    on: { click: _vm.confirmAdd }
                                  },
                                  [
                                    _c("v-icon", { attrs: { small: "" } }, [
                                      _vm._v("mdi-send")
                                    ])
                                  ],
                                  1
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        2949241013
                      ),
                      model: {
                        value: _vm.newTag,
                        callback: function($$v) {
                          _vm.newTag = $$v
                        },
                        expression: "newTag"
                      }
                    })
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "ml-1" },
                  [
                    _c(
                      "v-tooltip",
                      {
                        attrs: { top: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function(ref) {
                                var on = ref.on
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      {
                                        attrs: {
                                          loading: _vm.loading,
                                          icon: "",
                                          small: ""
                                        },
                                        on: { click: _vm.startAdd }
                                      },
                                      on
                                    ),
                                    [
                                      _c("icon-svg", {
                                        attrs: {
                                          name: "add-circle",
                                          size: "24",
                                          color: "var(--muted)"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1810820037
                        )
                      },
                      [_c("span", [_vm._v("Adicionar tag")])]
                    )
                  ],
                  1
                )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }